'use strict';

import asyncJS from 'async-js';

export default function f($q, $window, alert) {
  'ngInject';

  var alertConfig = {
    header: 'ALERTS.SCRIPT_ERROR.HEADER',
    buttons: [
      {

        label: 'ALERTS.SCRIPT_ERROR.BUTTON_ACCEPT',
        action: 'accept'
      }
    ]
  };

  function showAlert() {
    alert.show(alertConfig)
      .then(() => {
        $window.location.reload();
      });
  }

  return function (dependencyUrl, name, showErrorAlert = true) {
    return new $q((resolve, reject) => {
      let q = asyncJS(dependencyUrl);
      q.whenDone(function(_, __, errors) {
        if (!name && !showErrorAlert) {
          resolve();
          return;
        }
        if (errors.length || !$window[name]) {
          let error = new Error('Failed to load ' + name + ' script from ' + dependencyUrl + ' ' + errors.toString());
          showErrorAlert && showAlert();
          reject(error);
        } else {
          resolve($window[name]);
        }
      });
    });
  };
}



// WEBPACK FOOTER //
// ./app/src/services/js_loader.js